import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useScrollToTop(): void {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ left: 0, top: 0, behavior: 'instant' });
  }, [pathname]);
}
